import React from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import BreadcrumbBack from './BreadcrumbBack';

type IconType = React.FC<{ 'aria-hidden'?: boolean }>;
const PlusIcon = FiPlus as unknown as IconType;

interface Props {
  /** Last breadcrumb segment, e.g. "Drafts" (the trail is always Posts › current). */
  current: string;
  /** Label on the left of the action row, e.g. "📝 Drafts". */
  label: string;
  /** false on top-level pages (e.g. /projects) that have no parent to link back to. */
  showCrumb?: boolean;
  children?: React.ReactNode;
}

/** Phone-only page header: one-line breadcrumb plus a label with icon actions on the right.
 *  Hidden above 768px, where the regular page header is shown instead. */
const MobilePageBar: React.FC<Props> = ({ current, label, showCrumb = true, children }) => (
  <>
    {showCrumb && (
    <div className="breadcrumb mobile-page-crumb">
      <div className="breadcrumb-links">
        <BreadcrumbBack to="/posts" />
        <Link to="/posts">Posts</Link>
        <span className="breadcrumb-sep">›</span>
        <span>{current}</span>
      </div>
    </div>
    )}
    <div className={`mobile-page-bar${showCrumb ? '' : ' mobile-page-bar--solo'}`}>
      <span className="mobile-page-label">{label}</span>
      <div className="mobile-page-actions">{children}</div>
    </div>
  </>
);

export const NewPostButton: React.FC = () => (
  <Link to="/posts/compose" className="mobile-page-btn" title="New post" aria-label="New post">
    <PlusIcon aria-hidden={true} />
  </Link>
);

export default MobilePageBar;
